import { Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, VStack } from "@chakra-ui/react";

export default function UnifiedNumericalTable({ numericalResults }) {
  if (!numericalResults?.rows?.length) return null;

  const { columns, description, rows } = numericalResults;

  return (
    <VStack spacing={1} align="stretch">
      {description ? (
        <Text fontSize="sm" color="gray.500">
          {description}
        </Text>
      ) : null}

      <TableContainer border="1px solid" borderColor="gray.100" borderRadius="xl" overflow="hidden" bg="white">
        <Table variant="simple" size="sm">
          <Thead bg="gray.50">
            <Tr>
              <Th>{columns.item}</Th>
              <Th>{columns.metric}</Th>
              <Th>{columns.value}</Th>
              <Th>{columns.change}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {rows.map((row, index) => (
              <Tr key={`${row.item}-${index}`}>
                <Td fontWeight="bold" color="gray.800">
                  {row.item || "-"}
                </Td>
                <Td>{row.metric || "-"}</Td>
                <Td>{row.value || "-"}</Td>
                <Td>{row.change || "-"}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </VStack>
  );
}
